export enum IntegrationType {
  Agvance = 'Agvance',
}
